import { render, staticRenderFns } from "./BGPRoutes.vue?vue&type=template&id=ba5deb52&lang=pug&"
import script from "./BGPRoutes.vue?vue&type=script&lang=js&"
export * from "./BGPRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports